<main class="wrapper">
    <!-- SLIDER -->
    <section>
        <div id="carouselExampleCaptions" class="carousel slide cw-slider" data-ride="carousel">
            <ol class="carousel-indicators">
                <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
                <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
                <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
                <li data-target="#carouselExampleCaptions" data-slide-to="3"></li>
                <li data-target="#carouselExampleCaptions" data-slide-to="4"></li>
            </ol>
            <div class="carousel-inner">
                <div class="carousel-item ci-1 active">
                    <img src="../../assets/images/CityBusinessGrayed-min.png" alt="City Business Grayed">
                    <div class="carousel-caption d-flex flex-direction-column-responsive flex-md-row align-items-center-responsive align-items-center justify-content-between">
                        <p class="text animated fadeInLeft delay-1">The {{SiteName}} Solution:<br />Hyper-Converged & Hyper-Automated</p>
                        <div>
                            <span>PREPARE FOR </span>
                            <h2 class="title animated fadeInUp">THE<br /> FUTURE<br /> OF BUSINESS</h2>
                        </div>
                        <div class="list text-left">
                            <ul class="animated fadeInRight delay-2">
                                <li>Leverage our Free Solutions</li>
                                <li>Save Money & Generate Revenue</li>
                                <li>Online Sourcing, Bidding, and Selling</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="carousel-item ci-2">
                    <img src="../../assets/images/slider_2.png" class="d-block w-100 h-100" alt="City Business Grayed">
                    <div class="carousel-caption d-flex align-items-center justify-content-center justify-content-xl-between">
                        <div class="image d-none d-xl-flex">
                            <img src="../../assets/images/kids-new-min.png" class="img-responsive" width="685" alt="Kids">
                        </div>
                        <div class="caption">
                            <h2 class="title animated fadeInRight pb-md-3 delay200ms">Decades of Executive Leadership</h2>
                            <div class="list text-left">
                                <ul>
                                    <li class="animated fadeInRight pb-md-2 delay-2">Extensive experience in Public & Private sectors.</li>
                                    <li class="animated fadeInRight pb-md-2 delay-3">Strategic Sourcing & Global Supply Chain Initiatives.</li>
                                    <li class="animated fadeInRight pb-md-2 delay-4">Grants Managment.</li>
                                    <li class="lh-list animated fadeInRight delay-5">In-depth understanding of financial accounting<br /> systems & Federal, State, and Local regulations.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item ci-3">
                    <img src="../../assets/images/slider_3.png" class="d-block d-xl-none w-100 h-100" style="opacity:0.2" alt="Building">
                    <div class="carousel-caption d-flex align-items-center justify-content-between">
                        <div class="caption w-100">
                            <h2 class="text-left title animated fadeInLeft delay-0" id="slider3">Public Sector & Non-Profits</h2>
                            <p class="text-left text animated fadeInLeft delay-1">Top-rated, value driven solutions to improve & manage contract expenditures and supply chain needs.</p>
                            <div class="list text-left">
                                <ul>
                                    <li class="animated fadeInLeft delay-2">Portfolio of Cooperative Contracts & Compliance Solutions.</li>
                                    <li class="animated fadeInLeft delay-3">Sourcing and Bidding (eSourcing).</li>
                                    <li class="animated fadeInLeft delay-4">Contract Management.</li>
                                    <li class="animated fadeInLeft delay-5">Purchasing (eProcurement).</li>
                                </ul>
                            </div>
                        </div>
                        <img src="../../assets/images/slider_3.png" class="img-responsive d-none d-xl-flex" style="height:440px;position:relative;bottom:-40px;" alt="Building">
                    </div>
                </div>
                <div class="carousel-item ci-4">
                    <img src="../../assets/images/slider_4.png" class="d-block d-xl-none w-100 h-100" style="opacity:0.2" alt="Jet Fighter">
                    <div class="carousel-caption d-flex align-items-center justify-content-between">
                        <img src="../../assets/images/slider_4.png" class="img-responsive d-none d-xl-flex" style="height:440px;position:relative;bottom:-40px;" alt="Jet Fighter">
                        <div class="caption w-100 ml-md-4">
                            <h2 class="title animated fadeInUp">DEFENSE AND ARMED FORCES</h2>
                            <p class="text animated fadeInLeft delay-1">Hyper-Automation, decentralization, immutability, security, and transparency</p>
                            <div class="list text-left">
                                <ul class="animated fadeInRight delay-2">
                                    <li>Event Management (in-Person, Online, and Hybrid)</li>
                                    <li>e-Sourcing & e-Commerce</li>
                                    <li>Inventory Control & Warehousing</li>
                                    <li>Secure Webinars & Online Training</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item ci-5">
                    <img src="../../assets/images/slider_5.png" class="d-block d-xl-none w-100 h-100" style="opacity:0.2" alt="Health Care">
                    <div class="carousel-caption d-flex align-items-center justify-content-between">
                        <div class="caption w-100">
                            <h2 class="title animated fadeInRight delay200ms">HEALTH CARE </h2>
                            <p class="text animated fadeInLeft delay-1">HIPAA compliance with PKI Cybersecurity</p>
                            <div class="list text-left">
                                <ul>
                                    <li class="lh-list animated fadeInRight pb-md-2 delay-2">Direct from Manufacturer savings over Healthcare Distributors.</li>
                                    <li class="animated fadeInRight pb-md-2 delay-3">API & IoT Interfacing Capability.</li>
                                    <li class="lh-list animated fadeInRight pb-md-2 delay-4">Automated Invoice Payment Processes for 2 & 3-Way Matching Systems.</li>
                                    <li class="lh-list animated fadeInRight delay-5">Hyper-Automation Helps Compensate for Staffing Shortages</li>
                                </ul>
                            </div>
                        </div>
                        <img src="../../assets/images/slider_5.png" class="img-responsive d-none d-xl-flex" style="height:440px;position:relative;bottom:-40px;" alt="HEALTH CARE">
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </section>


    <!-- CARD -->
    <section class="container-fluid cw-card">
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-4 cw-card-item">
                <div class="cw-card-img">
                    <img src="../../assets/images/Compliance.png" class="img-responsive" alt="compliance">
                </div>
                <h3 class="cw-card-title">compliance</h3>
                <p class="cw-card-text">A portfolio of cooperative contracts, tools, and solutions that simplify the procurement process while maintaining compliance with Federal, State, and Local requirements.</p>
            </div>
            <div class="col-12 col-md-12 col-lg-4 cw-card-item">
                <div class="cw-card-img">
                    <img src="../../assets/images/Services.png" class="img-responsive" alt="services">
                </div>
                <h3 class="cw-card-title">services</h3>
                <p class="cw-card-text">Solve challenges using our tools and contracts to optimize your work to provide the best value possible.</p>
                <p class="cw-card-text">Other available services include; Solicitation management, Benchmarking, and Consulting.</p>
            </div>
            <div class="col-12 col-md-12 col-lg-4 cw-card-item">
                <div class="cw-card-img">
                    <img src="../../assets/images/lightbulb.png" class="img-responsive" alt="solutions">
                </div>
                <h3 class="cw-card-title">solutions</h3>
                <p class="cw-card-text"><b>Department workload outpacing staff resources?</b><br>Our tools help you stay on track, on time, and within budget.</p>
                <p class="cw-card-text"><b>Need help meeting goals or addressing multiple priorities?</b><br>Let us help you exceed purchasing compliance goals while dramatically reducing your workload.</p>
            </div>
        </div>
    </section>

    <!-- IMAGE TEXT -->
    <section class="container">
        <div class="row info-item">
            <div class="col-12 col-md-6 col-lg-6">
                <div class="info-image">
                    <img src="../../assets/images/BidsQuotes.png" width="495" height="472" class="img-responsive" alt="Bids Quotes">
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <div class="info-content">
                    <div>
                        <h1 class="info-title">Get bids and quotes</h1>
                        <a target="_blank" href="https://www.iconnectfx.com/view/bb2d3201-3a02-eb11-9977-00505682f257">WATCH VIDEO</a>
                    </div>
                    <ul class="info-list">
                        <li>Online sealed bids, proposals, quotations, reverse auctions, etc., easier and faster than ever before.</li>
                        <li>Advertise and engage with social media automatically to turbo-charge participation.</li>
                        <li>Best-And-Final-Offer and automated scoring with tabulated winner identification.</li>
                        <li>Track bid activity, access audit logs, and reduce the number of protests with more factual information.</li>
                    </ul>
                    <!--<a href="ClientLogin.aspx" class="btn btn-outline-info"><i class="icon-lock-closed"></i>Sign Up</a>-->
                </div>
            </div>
        </div>
        <div class="row info-item">
            <div class="col-12 col-md-6 col-lg-6 order-2 order-md-1">
                <div class="info-content">
                    <div>
                        <h2 class="info-title">Shop online using our extensive portfolio of contracts & cooperative contracts to find what you need FAST!</h2>
                        <a target="_blank" href="https://www.iconnectfx.com/view/bd2d3201-3a02-eb11-9977-00505682f257">WATCH VIDEO</a>
                    </div>

                    <ul class="info-list">
                        <li>Configure content to the exacting needs of your environment.</li>
                        <li>Set and automatically enforce sales participation goals for businesses matching your criteria (such as disadvantaged businesses).</li>
                        <li>Configuration options can automatically update pricing and availability to guard against order & invoicing challenges.</li>
                    </ul>
                    <!--<a href="ClientLogin.aspx" class="btn btn-outline-info"><i class="icon-lock-closed"></i>Learn More</a>-->
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 order-1 order-md-2">
                <div class="info-image">
                    <img src="../../assets/images/Shopping.png" width="495" height="606" class="img-responsive" alt="Shopping">
                </div>
            </div>
        </div>
        <div class="row info-item">
            <div class="col-12 col-md-6 col-lg-6">
                <div class="info-image">
                    <img src="../../assets/images/ManageContractsLikeNeverBefore.png" width="495" height="606" class="img-responsive" alt="Manage your contracts like never before">
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <div class="info-content">
                    <div>
                        <h2 class="info-title">Manage your contracts like never before</h2>
                        <a target="_blank" href="https://www.iconnectfx.com/view/bc2d3201-3a02-eb11-9977-00505682f257">WATCH VIDEO</a>
                    </div>
                    <br/>
                    <p class="info-text">At last, solicitation documents, attachments, contracts, and financial transactions are in one place.</p>
                    <ul class="info-list">
                        <li>Analyze & visualize data for better and faster insights.</li>
                        <li>Access numerous standard reports.</li>
                        <li>Intuitive tools and report writer allow one to easily create their own reports.</li>
                        <li>Schedule reports to run automatically at regular intervals-daily, weekly, or monthly.</li>
                    </ul>
                    <!--<a href="ClientLogin.aspx" class="btn btn-outline-info"><i class="icon-lock-closed"></i>Learn More</a>-->
                </div>
            </div>
        </div>
        <div class="row info-item">
            <div class="col-12 col-md-6 col-lg-6 order-2 order-md-1">
                <div class="info-content">
                    <div>
                        <h2 class="info-title">Financial Accounting & Grants Management</h2>
                        <!--<a href="">WATCH VIDEO</a>-->
                    </div>
                    <p class="info-text">Turbocharge the efficiency of your existing ERP/Financial Accounting System or replace it with ours!</p>
                    <ul class="info-list">
                        <li>Automated balance alerts.</li>
                        <li>Fixed asset management.</li>
                        <li>Organization-specific configuration.</li>
                        <li>Simple to use, wizard driven screens</li>
                    </ul>
                    <!--<a href="ClientLogin.aspx" class="btn btn-outline-info"><i class="icon-lock-closed"></i>Learn More</a>-->
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 order-1 order-md-2">
                <div class="info-image">
                    <img src="../../assets/images/FinancialAccounting.png" width="495" height="472" class="img-responsive" alt="Financial Accounting">
                </div>
            </div>
        </div>
        <div class="row info-item">
            <div class="col-12 col-md-6 col-lg-6">
                <div class="info-image">
                    <img src="../../assets/images/CommunityEngagement.png" width="495" height="472" class="img-responsive" alt="Community Engagement">
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <div class="info-content">
                    <div>
                        <h2 class="info-title">Community Engagement</h2>
                        <a target="_blank" href="https://www.iconnectfx.com/view/f52d3201-3a02-eb11-9977-00505682f257">WATCH VIDEO</a>
                    </div>
                    <br/>
                    <p class="info-text">Whether it is pre-bid meetings, church services, instructional videos, or conferences, we have a solution for you!</p>
                    <ul class="info-list">
                        <li>In-Person, Online, or Hybrid event management.</li>
                        <li>Secure Webinars that can be recorded and attached to solicitations or contracts.</li>
                        <li>Follow the contract through its entire life cycle.</li>
                        <li>Live Streaming and video sharing platform to engage your community or the world!</li>
                    </ul>
                    <!--<a href="ClientLogin.aspx" class="btn btn-outline-info"><i class="icon-lock-closed"></i>Sign Up</a>-->
                </div>
            </div>
        </div>
        <div class="row info-item">
            <div class="col-12 col-md-6 col-lg-6 order-2 order-md-1">
                <div class="info-content">
                    <div>
                        <h2 class="info-title">Reports & Dashboards</h2>
                    </div>
                    <ul class="info-list">
                        <li>Analyze & visualize data for better and faster insights.</li>
                        <li>Access numerous standard reports.</li>
                        <li>Intuitive tools and report writer allow one to easily create their own reports.</li>
                        <li>Schedule reports to run automatically at regular intervals-daily, weekly, or monthly.</li>
                    </ul>
                    <!--<a href="ClientLogin.aspx" class="btn btn-outline-info"><i class="icon-lock-closed"></i>Learn More</a>-->
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 order-1 order-md-2">
                <div class="info-image">
                    <img src="../../assets/images/DashboardSmall.png" width="495" height="525" class="img-responsive" alt="Reports & Dashboards">
                </div>
            </div>
        </div>
    </section>

    <!-- TEXT -->
    <section class="container">
        <div class="row">
            <div class="col-12">
                <div class="cw-content">
                    <!--<h2 class="cw-content-title">Membership Has Its� Benefits</h2>
                    <p>
                        The Co-op Way is not just another cooperative purchasing website! We provide you
                        with
                        the
                        tools you need in order to:
                    </p>
                    <div class="cw-content-list">
                        <ul>
                            <li>Create and advertise solicitations</li>
                            <li>Find existing competitively bid and publicly awarded contract(s)</li>
                            <li>Compare and make purchase(s) online</li>
                            <li>Manage your contracts</li>
                        </ul>
                    </div>
                    <div class="cw-content-space"></div>
                    <h2 class="cw-content-title">Become a Member Today</h2>
                    <p>
                        From sourcing to contract lifecycle management, you�ll discover the effortless way our members stay compliant.
                    </p>-->

                    <!--<div class="btn-wrp">
                        <a href="#" class="btn btn-long btn-primary">Vendors/Contractors</a>
                        <a href="#" class="btn btn-long btn-outline-info">Clients</a>
                    </div>-->
                </div>
            </div>
        </div>
    </section>

</main>
